@if (!isLoading()) {
  @if (!noHeader() && isShowCard()) {
    <app-hero-card-stats
      class="card width-100-percent"
      [hero]="selectedHero()!"
      [avatarUrl]="heroesAvatar()!"
      [isShowItems]="true"
      [isShowBarName]="true"
      [isShowExpBar]="true"
      [isLongCard]="true"
      [canClickItem]="true" />

    <div class="bg"></div>
  }
}
